export default {
  'test': '{attribute} - введите значение!',
  'locale.ru': 'Русский',
  'locale.en': 'Английский',
  'locale.short.ru': 'Рус',
  'locale.short.en': 'Анг',
  // helmet
  'helmet.authorize': 'Войти в систему',
  'helmet.register': 'Зарегистрироваться',
  'helmet.password.restore': 'Восстановить пароль',
  'helmet.password.change': 'Изменить пароль',
  'helmet.auth': 'Авторизация',
  'helmet.accessDenied': 'Доступ запрещен',
  'helmet.billing': 'Баланс',
  'helmet.companyInfo': 'Организация',
  'helmet.notices': 'Уведомления',
  'helmet.personalInfo': 'Персональная информация',
  'helmet.analytics': 'Аналитика',
  'helmet.bots': 'Боты',
  'helmet.collections': 'Коллекции',
  'helmet.collection': 'Коллекция - {name}',
  'helmet.collection.data': 'Коллекция - {name} - Данные',
  'helmet.collection.indexes': 'Коллекция - {name} - Индексы',
  'helmet.collection.schema': 'Коллекция - {name} - Схема',
  'helmet.collection.settings': 'Коллекция - {name} - Настройки',
  'helmet.collection.triggers': 'Коллекция - {name} - Триггеры',
  'helmet.applications': 'Приложения',
  'helmet.appServers': 'Сервера приложений',
  'helmet.processes': 'Процессы',
  'helmet.script.detail': 'Скрипт - {name}',
  'helmet.script.notFound': 'Скрипт не найден!',
  'helmet.script.list': 'Скрипты',
  'helmet.app.settings.community': 'Пользователи',
  'helmet.app.settings.developers': 'Разработчики',
  'helmet.app.settings.push': 'Настройки PUSH',
  'helmet.app.settings.npm': 'NPM зависимости',
  'helmet.app.settings.plans': 'Тарифный план',
  'helmet.app.settings.security': 'Безопасность',
  'helmet.app.settings.settings': 'Настройка приложения',
  // notifications
  'notification.title.error': 'Ошибка',
  'notification.title.success': 'Успех',
  'notification.title.notice': 'Уведомление',
  'notification.title.warning': 'Внимание!',
  // errors
  'error.code.403': 'Доступ запрещен.',
  'error.code.423': 'Только чтение.',
  'error.code.500': 'Внутренняя ошибка.',
  'error.code.601': 'Ошибка валидации исходных данных',
  'error.code.602': 'Сертификат не найден.',
  'error.code.603': 'Невалидный сертификат.',
  'error.code.604': 'Неверный тип сертификата.',
  'error.code.605': 'Неверная дата сертификата.',
  'error.code.606': 'Неверный ключ клиента.',
  'error.code.607': 'Неверный ключ доступа.',
  'error.code.608': 'Неверный тип ключа',
  'error.code.609': 'Неверное наименование приложения.',
  'error.code.610': 'Невалидный идентификатор.',
  'error.code.611': 'Ограничение тарифного плана.',
  'error.code.612': 'Неверный формат даты.',
  'error.code.613': 'Неверный тип даты.',
  'error.code.614': 'Неверные параметры оплаты.',
  'error.code.615': 'Необходим тарифный план Indie.',
  'error.code.616': 'Недостаточно средств для совершения операции.',
  'error.code.617': 'Платежная система не найдена.',
  'error.code.618': 'Платеж не выполнен.',
  'error.code.619': 'Ордер не найден.',
  'error.code.620': 'Ордер уже оплачен.',
  'error.code.621': 'Неверная сумма.',
  'error.code.622': 'Платежная система не поддерживается.',
  'error.code.623': 'В запросе не указан идентификатор ордера.',
  'error.code.624': 'Уведомление не найдено.',
  'error.code.625': 'Приложение не найдено.',
  'error.code.626': 'Приложение доступно только для чтения.',
  'error.code.627': 'Слишком короткое имя пользователя.',
  'error.code.628': 'Некоретный email.',
  'error.code.629': 'Слишком короткий пароль.',
  'error.code.630': 'Некоретный номер телефона.',
  'error.code.631': 'Некоретный ИНН.',
  'error.code.632': 'Некоретный КПП.',
  'error.code.633': 'Некоретный БИК.',
  'error.code.634': 'Некоретный ОГРН.',
  'error.code.635': 'Некорректный расчетный счет.',
  'error.code.636': 'Некорректный корреспондентский счет.',
  'error.code.637': 'Пользователь уже существует.',
  'error.code.638': 'Не указаны параметры аутентификации.',
  'error.code.639': 'Некорректные параметры аутентификации.',
  'error.code.640': 'Превышено количество попыток.',
  'error.code.641': 'Неверная капча.',
  'error.code.642': 'Пользователь не найден.',
  'error.code.643': 'Неверный код восстановления пароля.',
  'error.code.644': 'Телефонный номер уже используется.',
  'error.code.645': 'Тариф Indie заканчивается раньше данной опции.',
  'error.code.646': 'Невереное значение параметра "page".',
  'error.code.647': 'Aватар не найден.',
  // currencies
  'currency.rubles': 'рублей',
  // links
  'link.documents': 'https://scorocode.github.io/scorocode-docs/',
  // ACL
  'acl.create': 'Создание',
  'acl.read': 'Чтение',
  'acl.update': 'Изменение',
  'acl.remove': 'Удаление',
  // collection
  'collection.error.nothingToSave': 'Нет изменений для сохранения',
  'collection.error.fieldsNotValid': 'Не все поля имеют валидные значения',
  'collection.title.editArray': 'Редактировать массив',
  'collection.title.editObject': 'Редактировать объект',
  // confirm
  'confirm.title.removeDocument': 'Вы действительно хотите удалить документ?',
  'confirm.title.removeBot': 'Вы действительно хотите удалить бота?',
  'confirm.title.removeServer': 'Вы действительно хотите удалить сервер?',
  // tree
  'tree.emptyFolder': '(пусто)',
  'tree.label.downloading': 'загрузка',
  // date
  'date.label.year': 'Год',
  'date.label.month': 'Месяц',
  'date.label.day': 'День',
  // actions
  'action.download': 'Загрузить',
  'action.further': 'Далее',
  'action.apply': 'Применить',
  'action.refresh': 'Обновить',
  'action.approve': 'Подтвердить',
  'action.remove': 'Удалить',
  'action.cancel': 'Отмена',
  'action.upload': 'Загрузить',
  'action.change': 'Изменить',
  'action.save': 'Сохранить',
  'action.pay': 'Оплатить',
  'action.purchase': 'Приобрести',
  'action.payWithBonuses': 'Купить бонусами',
  'action.createScript': 'Создать скрипт',
  'action.createFolder': 'Создать папку',
  'action.createServerCode': 'Создать серверный обработчик',
  'action.addCollection': 'Добавить коллекцию',
  'action.removeCollection': 'Удалить коллекцию',
  'action.createIndex': 'Добавить индекс',
  'action.addDocument': 'Добавить документ',
  'action.addField': 'Добавить поле',
  'action.addFilter': 'Добавить фильтр',
  'action.removeFilter': 'Удалить фильтр',
  'action.clearFilter': 'Сбросить фильтр',
  'action.filter': 'Фильтр',
  'action.saveChanges': 'Сохранить изменения',
  'action.saveChangesAndRun': 'Сохранить и запустить',
  'action.removeApp': 'Удалить приложение',
  'action.create': 'Создать',
  'action.invite': 'Пригласить',
  'action.changeCaptcha': 'Сменить капчу',
  'action.logIn': 'Войти',
  'action.beginDevelopment': 'Начать разработку',
  'action.restore': 'Восстановить',
  'action.send': 'Отправить',
  'action.changePassword': 'Изменить пароль',
  'action.cardPayment': 'Оплата картой',
  'action.add': 'Добавить',
  'action.activate': 'Активировать',
  'action.applyFilter': 'Применить фильтр',
  'action.sortByAsc': 'По возрастанию',
  'action.sortByDesc': 'По убыванию',
  'action.cancelChanges': 'Сбросить изменения',
  'action.editDocument': 'Редактировать документ',
  'action.removeDocument': 'Удалить документ',
  'action.select': 'Выбрать',
  'action.deselect': 'Исключить',
  'action.addDependencies': 'Добавить зависимости',
  'action.removeDependencies': 'Удалить зависимости',
  'action.selectDependency': 'Выбрать зависимость',
  'action.clear': 'Очистить',
  'action.changeValue': 'Изменить значение',
  'action.downloadFile': 'Скачать файл {name}',
  'action.selectDate': 'Выбрать дату',
  'action.selectTime': 'Выбрать время',
  'action.createBot': 'Создать бота',
  'action.edit': 'Редактировать',
  'action.update': 'Обновить',
  'action.runScript': 'Запустить скрипт',
  'action.filterOnlySelected': 'Только выбранные',
  'action.reset': 'Сбросить',
  'action.changeDependencies': 'Изменить зависимости',
  'action.uploadIosCertificate': 'Загрузить сертификат',
  'action.start': 'Запустить',
  'action.stop': 'Остановить',
  // tables
  'table.header.name': 'Наименование',
  'table.header.personalName': 'Имя',
  'table.header.date': 'Дата',
  'table.header.sum': 'Сумма',
  'table.header.status': 'Статус',
  'table.header.email': 'Email',
  'table.header.actions': 'Действия',
  'table.header.optionName': 'Название опции',
  'table.header.count': 'Количество',
  'table.header.buyDate': 'Дата приобретения',
  'table.header.endDate': 'Дата окончания',
  'table.header.months': 'Месяцев',
  'table.header.discount': 'Скидка',
  'table.header.total': 'Итого',
  'table.header.price': 'Цена',
  'table.header.pricePerMonth': 'Цена / месяц',
  'table.header.pricePerYear': 'Цена / год',
  'table.header.indexName': 'Название индекса',
  'table.header.index': 'Индекс',
  'table.header.fieldName': 'Название поля',
  'table.header.sort': 'Сортировка',
  'table.header.botName': 'Название бота',
  'table.header.telegramId': 'Telegram ID',
  'table.header.scriptId': 'Script ID',
  'table.label.status.active': 'Активен',
  'table.label.status.inactive': 'Не активен',
  'table.label.status.started': 'Запущен',
  'table.label.status.stopped': 'Остановлен',
  // nav
  'nav.label.language': 'Язык',
  'nav.label.applications': 'Приложения',
  'nav.label.documentation': 'Документация',
  'nav.label.notices': 'Уведомления',
  'nav.label.support': 'Тех. поддержка',
  'nav.label.info': 'Информация',
  'nav.label.organization': 'Организация',
  'nav.label.balance': 'Баланс',
  'nav.label.quit': 'Выход',
  'nav.label.data': 'Данные',
  'nav.label.settings': 'Настройки',
  'nav.label.schema': 'Схема',
  'nav.label.indexes': 'Индексы',
  'nav.label.triggers': 'Триггеры',
  'nav.label.analytics': 'Аналитика',
  'nav.label.serverCode': 'Серверный код',
  'nav.label.notifications': 'Рассылки',
  'nav.label.downloadSdk': 'Загрузить SDK',
  'nav.label.code': 'Код',
  'nav.label.bots': 'Боты',
  'nav.label.roles': 'Роли',
  'nav.label.users': 'Пользователи',
  'nav.label.gitter': 'Gitter',
  'nav.label.appServers': 'Сервера приложений',
  // footer
  'footer.label.allRightsReserved': 'Все права защищены.',
  // forms
  'form.control.placeholder.typeUserName': 'Введите имя пользователя',
  'form.control.placeholder.typeRoleName': 'Введите название роли',
  'form.control.label.wsNotify': 'WebSocket уведомления',
  'form.control.label.operator': 'Оператор',
  'form.control.label.value': 'Значение',
  'form.control.label.name': 'Название',
  'form.control.label.path': 'Путь',
  'form.control.label.description': 'Описание',
  'form.control.label.email': 'Email',
  'form.control.label.personalName': 'Имя',
  'form.control.placeholder.search': 'Поиск',
  'form.control.label.confirmAppRemove': 'Для подтверждения введите название приложения',
  'form.control.error.confirmAppRemove': '^Укажите точное название удаляемого приложения',
  'form.control.label.beginDate': 'Дата начала',
  'form.control.label.endDate': 'Дата окончания',
  'form.control.label.type': 'Тип',
  'form.control.label.appName': 'Название приложения',
  'form.control.label.appDescription': 'Описание приложения',
  'form.control.label.image': 'Изображение',
  'form.control.label.sessionTimeout': 'Завершить сессию по истечении {control} часов',
  'form.control.title.sessionTimeout': 'Длительность пользовательской сессии',
  'form.control.title.verifyRegistration': 'Подтверждение регистрации',
  'form.control.label.sendEmailVerified': 'Высылать письмо подтверждения email пользователям для завершения регистрации',
  'form.control.label.emailTemplate': 'Шаблон письма',
  'form.control.label.typeAppName': 'Введите имя приложения',
  'form.control.label.migrateFromParse': 'Миграция с Parse',
  'form.control.label.ParseLogin': 'Логин Parse',
  'form.control.label.ParsePassword': 'Пароль Parse',
  'form.control.label.ParseApplicationId': 'Application ID',
  'form.control.placeholder.enterEmail': 'Введите Email',
  'form.control.label.gcmSenderId': 'GCM Sender ID',
  'form.control.label.apiKey': 'API key',
  'form.control.placeholder.enterYourEmail': 'Введите ваш Email',
  'form.control.placeholder.enterYourPassword': 'Введите ваш пароль',
  'form.control.placeholder.enterCaptchaCode': 'Введите код капчи',
  'form.control.placeholder.enterYourName': 'Введите ваше имя',
  'form.control.label.licenseAgreement': 'Я принимаю условия {link} и согласен получать email рассылку',
  'form.control.label.licenseAgreement.link': 'лицензионного соглашения',
  'form.control.label.subject': 'Тема',
  'form.control.label.messageText': 'Текст сообщения',
  'form.control.label.newPassword': 'Новый пароль',
  'form.control.label.confirmPassword': 'Подтверждение',
  'form.control.placeholder.sumPayment': 'Сумма пополнения',
  'form.control.label.organizationName': 'Название',
  'form.control.label.urAddress': 'Юридический адрес',
  'form.control.label.factAddress': 'Фактический адрес',
  'form.control.label.phone': 'Телефонный номер',
  'form.control.label.ogrn': 'ОГРН',
  'form.control.label.inn': 'ИНН',
  'form.control.label.kpp': 'КПП',
  'form.control.label.settlAcc': 'Расчетный счет',
  'form.control.label.corrAcc': 'Корреспондентский счёт',
  'form.control.label.bankName': 'Название банка',
  'form.control.label.bik': 'БИК банка',
  'form.control.label.collectionName': 'Название коллекции',
  'form.control.label.fieldName': 'Название поля',
  'form.control.label.dataType': 'Тип данных',
  'form.control.label.collection': 'Коллекция',
  'form.control.label.indexName': 'Название индекса',
  'form.control.label.indexFields': 'Поля индекса',
  'form.control.label.isSystem': 'Системный',
  'form.option.selectItem': 'Выбрать...',
  'form.control.label.useDocumentAcl': 'Использовать ACL документов',
  'form.acl.label.anonymousUsers': 'Анонимные пользователи',
  'form.control.title.unauthorizedAcl': 'ACL анонимных пользователей',
  'form.control.title.usersAcl': 'ACL пользователей',
  'form.control.title.rolesAcl': 'ACL ролей',
  'form.multiselect.emptyList': 'Совпадений не найдено',
  'form.control.label.folderName': 'Название папки',
  'form.control.label.scriptName': 'Название скрипта',
  'form.title.users': 'Пользователи',
  'form.title.roles': 'Роли',
  'form.control.label.allowAnonymousLaunch': 'Разрешить анонимный запуск',
  'form.title.scheduleStart': 'Запланировать запуск',
  'form.control.label.timerOn': 'Включить таймер',
  'form.control.label.jobStartAt': 'Начало действия',
  'form.control.label.launch': 'Запустить',
  'form.control.label.withinDays': 'Через дней',
  'form.control.label.days': 'дней',
  'form.control.label.hours': 'часов',
  'form.control.label.minutes': 'минут',
  'form.control.label.selectDayOfWeek': 'Выбор дня недели',
  'form.control.label.selectTime': 'Выбор точного времени',
  'form.control.label.selectMonth': 'Выбор месяца',
  'form.control.label.selectDay': 'Выбор дня',
  'form.control.label.last': 'Последний',
  'form.control.label.jobType.once': 'Единожды',
  'form.control.label.jobType.custom': 'Произвольно',
  'form.control.label.jobType.daily': 'Ежедневно',
  'form.control.label.jobType.monthly': 'Ежемесячно',
  'form.control.label.day.monday': 'Понедельник',
  'form.control.label.day.tuesday': 'Вторник',
  'form.control.label.day.wednesday': 'Среда',
  'form.control.label.day.thursday': 'Четверг',
  'form.control.label.day.friday': 'Пятница',
  'form.control.label.day.saturday': 'Суббота',
  'form.control.label.day.sunday': 'Воскресенье',
  'form.control.label.month.january': 'Январь',
  'form.control.label.month.february': 'Февраль',
  'form.control.label.month.march': 'Март',
  'form.control.label.month.april': 'Апрель',
  'form.control.label.month.may': 'Май',
  'form.control.label.month.june': 'Июнь',
  'form.control.label.month.july': 'Июль',
  'form.control.label.month.august': 'Август',
  'form.control.label.month.september': 'Сентябрь',
  'form.control.label.month.october': 'Октябрь',
  'form.control.label.month.november': 'Ноябрь',
  'form.control.label.month.december': 'Декабрь',
  'form.option.selectField': 'Выбрать поле...',
  'form.option.selectOperator': 'Выбрать оператор...',
  'form.option.notSet': 'не задано',
  'form.control.label.botName': 'Название бота',
  'form.control.label.botId': 'Идентификатор бота',
  'form.control.label.scriptId': 'Идентификатор скрипта',
  'form.control.label.isBotActive': 'Бот включен',
  'form.control.placeholder.log': 'Лог',
  'form.control.label.allowAll': 'Разрешить всем',
  'form.control.label.autoRun': 'Автозапуск',
  'form.control.label.isRunning': 'Сервер запущен',
  'form.validate.presence': 'Это поле необходимо заполнить',
  'form.validate.numericality.notValid': 'Укажите числовое значение',
  'form.validate.numericality.notInteger': 'Укажите число в десятичном формате',
  'form.validate.numericality.notOdd': 'Укажите нечетное число',
  'form.validate.numericality.notEven': 'Укажите четное число',
  'form.validate.numericality.notEqualTo': 'Значение должно быть равно {count}',
  'form.validate.numericality.notDivisibleBy': 'Значение не делиться на {count}',
  'form.validate.numericality.notGreaterThan': 'Значение должно быть больше {count}',
  'form.validate.numericality.notGreaterThanOrEqualTo': 'Значение должно быть больше или равно {count}',
  'form.validate.numericality.notLessThan': 'Значение должно быть меньше {count}',
  'form.validate.numericality.notLessThanOrEqualTo': 'Значение должно быть меньше или равно {count}',
  'form.validate.length.minimum': 'Укажите минимум {count, plural, one {один символ} few {# символа} many {# символов} other {# символов}}',
  'form.validate.email': 'Введите корректный Email',
  'form.validate.image': 'Загруженный фаил не является изображением',
  'form.validate.ace': 'Это поле имеет не верный {format} формат',
  'form.validate.json': 'Это поле имеет не верный JSON формат',
  'form.validate.agreeLicense': 'Примите условия лицензионного соглашения',
  'form.validate.inclusion': '%{value} не входит в список допустимых значений',
  'form.validate.isArrayJson': 'Json объект должен быть типа "Array"',
  'form.validate.isObjectJson': 'Json объект должен быть типа "Object"',
  'form.validate.isDateObject': 'Поле имеет не верный формат даты',
  'form.validate.presenceYourEmail': 'Введите вашу почту',
  'form.validate.presenceYourPassword': 'Введите ваш пароль',
  'form.validate.presenceYourConfirmPassword': 'Подтвердите новый пароль пароль',
  'form.validate.presenceYourName': 'Введите ваше имя',
  'form.validate.presenceCaptcha': 'Введите код капчи',
  'form.validate.passwordNotConfirmed': 'Пароль не совпадает',
  // modals
  'modal.title.supportRequest': 'Запрос в тех. поддержку',
  'modal.title.createBot': 'Создать бота',
  'modal.title.updateBot': 'Обновить бота',
  'modal.title.createAppServer': 'Создать сервер приложений',
  'modal.title.updateAppServer': 'Обновить сервер приложений',
  // messages
  'message.pageNotFound': 'Страница не найдена!',
  'message.messageSend': 'Сообщение отправлено',
  'message.accountCreated': 'Аккаунт создан, подробности на почте',
  'message.restorePasswordSuccess': 'На вашу почту высланы инструкции по смене пароля',
  'message.dataChanged': 'Данные изменены',
  'message.dataSaved': 'Данные сохранены',
  'message.settingsChanged': 'Настройки изменены',
  'message.passwordChanged': 'Пароль изменен',
  'message.noticeRemoved': 'Уведомление удалено',
  'message.noticeApproved': 'Уведомление подтверждено',
  'message.appCreated': 'Приложение создано',
  'message.appRemoved': 'Приложение "{name}" удалено',
  'message.certificateLoaded': 'Сертификат загружен',
  'message.developerRemoved': 'Разработчик удален',
  'message.developerInviteSend': 'Пользователю отправлено письмо с запросом',
  'message.paymentComplete': 'Платеж совершен',
  'message.planFreeUpgradeAlert': 'Для приобритения дополнительных опций необходимо перейти на тарифный план INDIE',
  'message.appAclSettingsSaved': 'Настройки ACL сохранены',
  'message.appKeyGenerated': 'Новый {key} ключ сгенерирован',
  'message.serverCodeCreated': 'Серверный код "{name}" создан',
  'message.serverCodeRemoved': 'Серверный обработчик удален',
  'message.folderCreated': 'Папка создана',
  'message.folderRemoved': 'Папка удалена',
  'message.serverCodeSaved': 'Код изменен',
  'message.collectionCreated': 'Коллекция "{name}" создана',
  'message.collectionRemoved': 'Коллекция удалена',
  'message.triggerSaved': 'Триггер обновлен',
  'message.indexRemoved': 'Индекс удален',
  'message.indexCreated': 'Индекс добавлен',
  'message.documentCreated': 'Документ создан',
  'message.documentRemoved': 'Документ удален',
  'message.documentUpdated': 'Документ изменен',
  'message.documentsRemoved': '{count, plural, one {Документ удален} few {Удалено # документа} many {Удалено # документов} other {Удалено # документа}}',
  'message.collectionFieldRemoved': 'Поле "{name}" удалено из коллекции',
  'message.collectionFieldCreated': 'Поле "{name}" добавлено',
  'message.botCreated': 'Бот создан',
  'message.botRemoved': 'Бот удален',
  'message.botUpdated': 'Бот изменен',
  // auth
  'auth.label.register' : 'Регистрация',
  'auth.label.forgetPassword' : 'Забыли пароль?',
  'auth.label.logIntoAccount' : '{logIn}, если у вас есть аккаунт.',
  'auth.label.logIn' : 'Войти',
  'auth.label.logInto' : 'Войдите',
  // profile index
  'profile.index.label.notices': 'Уведомления',
  'profile.index.label.info': 'Персональная информация',
  'profile.index.label.changePassword': 'Изменение пароля',
  'profile.index.label.organization': 'Организация',
  'profile.index.label.balance': 'Баланс',
  // profile notices
  'profile.notices.title.notices': 'Уведомления',
  // profile balance
  'profile.balance.title.balance' : 'Баланс',
  'profile.balance.title.detail' : 'Детализация платежей',
  'profile.balance.label.balance' : 'Текущий баланс',
  'profile.balance.label.bonuses' : 'Бонусы',
  'profile.balance.status.completed' : 'Исполнено',
  'profile.balance.status.notCompleted' : 'Не исполнено',
  'profile.balance.label.pay_indie': 'Тариф Indie',
  'profile.balance.label.pay_developers': 'Безлимитное количество разработчиков на приложении',
  'profile.balance.label.pay_rps': 'Запросы к API в секунду',
  'profile.balance.label.pay_ws': 'Подключения websocket',
  'profile.balance.label.pay_store': 'Место в облачном хранилище',
  'profile.balance.label.pay_scriptTimeout': 'Время обработки серверного кода',
  'profile.balance.label.pay_push': 'PUSH-сообщения',
  // profile info
  'profile.info.title.personalInfo': 'Персональная информация',
  // profile change password
  'profile.password.title.changePassword': 'Изменение пароля',
  // profile organization
  'profile.organization.title.organization': 'Организация',
  // app list
  'app.list.title.applications': 'Приложения',
  'app.list.label.createApp': 'Создать приложение',
  'app.list.label.newApp': 'Новое приложение',
  'app.list.label.nothingFound': 'Ничего не найдено',
  // app analytics
  'app.analytics.graph.notices.title': 'Уведомления',
  'app.analytics.graph.storage.title': 'Размер данных',
  'app.analytics.graph.users.title' : 'Пользователи',
  'app.analytics.graph.overall.title': 'Общее количество запросов',
  'app.analytics.graph.android.title': 'Android',
  'app.analytics.graph.ios.title': 'iOS',
  'app.analytics.graph.javascript.title': 'JavaScript',
  'app.analytics.graph.trigger.title': 'Триггеры',
  'app.analytics.graph.winphone.title': 'WinPhone',
  // app settings
  'app.settings.nav.label.settings': 'Настройка приложения',
  'app.settings.nav.label.plans': 'Тарифный план',
  'app.settings.nav.label.security': 'Безопасность',
  'app.settings.nav.label.notification': 'Настройки Push',
  'app.settings.nav.label.developers': 'Разработчики',
  'app.settings.nav.label.auth': 'Пользователи',
  'app.settings.nav.label.npm': 'NPM зависимости',
  'app.settings.confirmRemove.title': 'Вы действительно хотите удалить приложение?',
  'app.settings.notification.title.iosPush': 'iOs пуш',   // todo
  'app.settings.notification.title.androidPush': 'Android пуш',   // todo
  'app.settings.developers.title.developers': 'Разработчики',
  'app.settings.info.title.info': 'Настройка приложения',
  'app.settings.npm.title.npm': 'NPM зависимости',
  'app.settings.security.title.acl': 'ACL',
  'app.settings.security.title.appKeys': 'Ключи приложения',
  'app.settings.security.title.clientKeys': 'Клиентские ключи',
  'app.settings.security.acl.label': 'Разрешить анонимный доступ к данным',
  'app.settings.security.confirm.generateKey': 'Вы действительно хотите сгенерировать новый ключ?',
  'app.settings.billing.history.rps': '+{count} запросов к API в секунду',
  'app.settings.billing.history.store': '+{count} Гб облачного хранилища',
  'app.settings.billing.history.push': '+{count} PUSH-уведомлений',
  'app.settings.billing.history.ws': '+{count} одновременных подключений WebSocket',
  'app.settings.billing.history.scriptTimeout': '+{count} секунд ко времени выполнения серверного кода',
  'app.settings.billing.history.developers': 'Безлимитное число разработчиков на приложении',
  'app.settings.plans.title.plan': 'Тарифный план',
  'app.settings.plans.title.selectPlan': 'Выберите тарифный план',
  'app.settings.plans.title.activeOptions': 'Список текущих активных опций',
  'app.settings.plans.title.upgradePlan': 'Улучшение тарифа',
  'app.settings.plans.label.currentPlan': 'Текущий тариф',
  'app.settings.plans.label.requestsPerSecond': 'Запросов в секунду',
  'app.settings.plans.label.store': 'Хранилище',
  'app.settings.plans.label.push': 'Push уведомления',
  'app.settings.plans.label.ws': 'WebSocket - количество одновременных подключений',
  'app.settings.plans.label.scriptTimeout': 'Время выполнения серверного кода',
  'app.settings.plans.label.developersCount': 'Количество разработчиков',
  'app.settings.plans.label.developers.unlimited': 'Неограничено',
  'app.settings.plans.label.indieSale': 'Акция! 3 месяца тарифа Indie за 990 рублей!',
  'app.settings.plans.label.free': 'Free',
  'app.settings.plans.label.indie': 'Indie',
  'app.settings.plans.label.enterpriseS': 'Enterprise S',
  'app.settings.plans.label.enterpriseM': 'Enterprise M',
  'app.settings.plans.label.enterpriseL': 'Enterprise L',
  'app.settings.plans.tariff.free': 'Тарифный план FREE',
  'app.settings.plans.tariff.indie': 'Тарифный план INDIE',
  'app.settings.plans.tariff.enterpriseS': 'Тарифный план ENTERPRISE S',
  'app.settings.plans.tariff.enterpriseM': 'Тарифный план ENTERPRISE M',
  'app.settings.plans.tariff.enterpriseL': 'Тарифный план ENTERPRISE L',
  'app.settings.plans.tariff.rps': '+10 запросов к API в секунду',
  'app.settings.plans.tariff.store': '+1 Гб облачного хранилища',
  'app.settings.plans.tariff.push': '+100 000 PUSH-уведомлений',
  'app.settings.plans.tariff.ws': '+1 000 одновременных подключений WebSocket',
  'app.settings.plans.tariff.scriptTimeout': 'Время выполнения серверного кода',
  'app.settings.plans.tariff.developers': 'Безлимитное число разработчиков на приложении',
  'app.settings.plans.label.Gb': 'Гб',
  'app.settings.plans.label.remains': 'осталось',
  // payment confirm
  'app.settings.billing.pay.confirm.indie': 'Подтвердите покупку тарифного плана INDIE на {months, plural, one {# месяц} few {# месяца} many {# месяцев} other {# месяца}}',
  'app.settings.billing.pay.confirm.enterpriseS': 'Подтвердите покупку тарифного плана ENTERPRISE S на {months, plural, one {# месяц} few {# месяца} many {# месяцев} other {# месяца}}',
  'app.settings.billing.pay.confirm.enterpriseM': 'Подтвердите покупку тарифного плана ENTERPRISE M на {months, plural, one {# месяц} few {# месяца} many {# месяцев} other {# месяца}}',
  'app.settings.billing.pay.confirm.enterpriseL': 'Подтвердите покупку тарифного плана ENTERPRISE L на {months, plural, one {# месяц} few {# месяца} many {# месяцев} other {# месяца}}',
  'app.settings.billing.pay.confirm.rps': 'Подтвердите покупку {count, plural, one {# запрос} few {# запроса} many {# запросов} other {# запроса}} к API в секунду на {months, plural, one {# месяц} few {# месяца} many {# месяцев} other {# месяца}}',
  'app.settings.billing.pay.confirm.store': 'Подтвердите покупку {count} Гб облачного хранилища на {months, plural, one {# месяц} few {# месяца} many {# месяцев} other {# месяца}}',
  'app.settings.billing.pay.confirm.push': 'Подтвердите покупку {count, plural, one {# PUSH-уведомления} few {# PUSH-уведомлений} many {# PUSH-уведомлений} other {# PUSH-уведомления}} к API в секунду на {months, plural, one {# месяц} few {# месяца} many {# месяцев} other {# месяца}}',
  'app.settings.billing.pay.confirm.ws': 'Подтвердите покупку {count, plural, one {# одновременного WebSocket подключения} few {# одновременных WebSocket подключений} many {# одновременных WebSocket подключений} other {# одновременных WebSocket подключений}} к API в секунду на {months, plural, one {# месяц} few {# месяца} many {# месяцев} other {# месяца}}',
  'app.settings.billing.pay.confirm.scriptTimeout': 'Подтвердите покупку {count, plural, one {# дополнительной секунды} few {# дополнительных секунд} many {# дополнительных секунд} other {# дополнительных секунд}} ко времени исполнения серверного кода на {months, plural, one {# месяц} few {# месяца} many {# месяцев} other {# месяца}}',
  'app.settings.billing.pay.confirm.developers': 'Подтвердите покупку возможности безлимитного количества возможных разработчиков приложения на {months, plural, one {# месяц} few {# месяца} many {# месяцев} other {# месяца}}',
  'app.settings.billing.pay.confirm.indieSale': 'Подтвердите покупку тарифного плана INDIE на 3 месяца по акции',
  // server code
  'app.serverCode.title.createServerCode': 'Создать серверный обработчик',
  'app.serverCode.title.newFolder': 'Новая папка',
  'app.serverCode.confirm.removeFolder': 'Вы действительно хотите удалить папку?',
  'app.serverCode.confirm.removeServerCode': 'Вы действительно хотите удалить серверный обработчик?',
  // collections
  'app.collections.title.addDocument': 'Добавить документ',
  'app.collections.title.updateDocument': 'Редактировать документ',
  'app.collections.title.addCollection': 'Добавить коллекцию',
  'app.collections.nav.afterInsert': 'После добавления',
  'app.collections.nav.afterRemove': 'После удаления',
  'app.collections.nav.afterUpdate': 'После обновления',
  'app.collections.nav.beforeInsert': 'Перед добавлением',
  'app.collections.nav.beforeRemove': 'Перед удалением',
  'app.collections.nav.beforeUpdate': 'Перед обновлением',
  'app.collections.title.createIndex': 'Добавить индекс',
  'app.collections.settings.confirmRemove.title': 'Вы действительно хотите удалить коллекцию?',
  'app.collections.settings.confirmRemove.index': 'Вы действительно хотите удалить индекс?',
  'app.collections.settings.confirmRemove.field': 'Вы действительно хотите удалить поле?',
  // telegram bots
  'app.bots.title.telegramBots': 'Telegram боты',
  // documents
  'app.documents.confirm.removeSelectedDocuments': 'Вы действительно хотите удалить выбранные документы?',
  'app.documents.title.addField': 'Добавить поле',
  // instances
  'app.instances.title.appServers': 'Сервера приложений',
  'app.instances.title.processes': 'Процессы',
}


// WEBPACK FOOTER //
// ./src/messages/locale_ru.js